module.exports = __webpack_public_path__ + "116cac07f0b42abe11fb4d5a517459c1.svg";